export default __webpack_public_path__ + "static/media/video-audio-mute.01729c25.svg";